import { render, staticRenderFns } from "./assessment.vue?vue&type=template&id=0727f610&scoped=true&"
import script from "./assessment.vue?vue&type=script&lang=js&"
export * from "./assessment.vue?vue&type=script&lang=js&"
import style0 from "./assessment.vue?vue&type=style&index=0&id=0727f610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727f610",
  null
  
)

export default component.exports